/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_Map_HintInputs */

const en_pwf_map_hint = /** @type {(inputs: Pwf_Map_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every status that has items needs a status in the new workflow. We suggested the closest match.`)
};

const de_pwf_map_hint = /** @type {(inputs: Pwf_Map_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeder Status mit Vorgängen braucht einen Status im neuen Workflow. Wir haben die nächstliegende Entsprechung vorgeschlagen.`)
};

/**
* | output |
* | --- |
* | "Every status that has items needs a status in the new workflow. We suggested the closest match." |
*
* @param {Pwf_Map_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_map_hint = /** @type {((inputs?: Pwf_Map_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_Map_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_map_hint(inputs)
	return en_pwf_map_hint(inputs)
});